module.exports = __webpack_public_path__ + "img/threeFingerThrowText4.f00c976d.png";